import React from 'react';
import { Link } from 'react-router-dom';
import PageWrapper from '../components/PageWrapper';
import HeroSection from '../components/HeroSection';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const InternationaleFachkraefte = () => {
  const steps = [
    { title: 'Bewerbung', desc: 'Senden Sie uns Ihren Lebenslauf und Zeugnisse.' },
    { title: 'Prüfung', desc: 'Wir prüfen Ihre Unterlagen und die Möglichkeiten der Anerkennung in Deutschland.' },
    { title: 'Matching', desc: 'Wir suchen Arbeitgeber, die internationale Fachkräfte einstellen und unterstützen.' },
    { title: 'Ankunft', desc: 'Unterstützung bei der Integration (Sprache, Wohnungssuche über Arbeitgeber, etc.).' }
  ];

  return (
    <PageWrapper>
      <HeroSection 
        title="Arbeiten in Deutschland" 
        subtitle="Wir unterstützen internationale Fachkräfte und Migranten beim Start in den deutschen Arbeitsmarkt."
        bgImage="https://images.unsplash.com/photo-1529390079861-591de354faf5?ixlib=rb-1.2.1&auto=format&fit=crop&w=1920&q=80"
        cta1={{ text: 'Jetzt Bewerben', link: '/bewerber' }}
      />

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-3xl font-bold text-blue-900 mb-6">Für Bewerber aus dem Ausland & Migranten</h2>
            <p className="text-slate-600 text-lg leading-relaxed">
              Deutschland braucht gut ausgebildete Fachkräfte. Egal ob Sie bereits in Deutschland leben oder aus dem Ausland zuwandern möchten – wir sind Ihr Ansprechpartner für die Branchen Pflege, Handwerk, Logistik, Ingenieurwesen und Gastronomie.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
            <div>
              <h3 className="text-2xl font-bold text-blue-900 mb-4">Unser Service für Sie</h3>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <SafeIcon icon={FiIcons.FiCheckCircle} className="h-6 w-6 text-cyan-500 mr-3 shrink-0 mt-0.5" />
                  <span className="text-slate-700"><strong>Sprachliche Unterstützung:</strong> Wir kommunizieren auch auf Englisch, Türkisch und Farsi/Dari.</span>
                </li>
                <li className="flex items-start">
                  <SafeIcon icon={FiIcons.FiCheckCircle} className="h-6 w-6 text-cyan-500 mr-3 shrink-0 mt-0.5" />
                  <span className="text-slate-700"><strong>Anerkennung:</strong> Beratung zu benötigten Unterlagen für die Anerkennung ausländischer Abschlüsse.</span>
                </li>
                <li className="flex items-start">
                  <SafeIcon icon={FiIcons.FiCheckCircle} className="h-6 w-6 text-cyan-500 mr-3 shrink-0 mt-0.5" />
                  <span className="text-slate-700"><strong>Arbeitgeber-Netzwerk:</strong> Vermittlung an Unternehmen, die offen für internationale Teams sind und oft bei der Wohnungssuche helfen.</span>
                </li>
              </ul>
              
              <div className="mt-8 p-4 bg-blue-50 border-l-4 border-blue-900 rounded-r-md">
                <p className="text-sm text-blue-900 font-medium">
                  Wichtiger Hinweis: Wir bieten keine rechtliche Beratung zu Visa oder Aufenthaltsrecht an. Wir konzentrieren uns rein auf die Arbeitsvermittlung.
                </p>
              </div>
            </div>

            <div>
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-slate-100 p-6 rounded-xl text-center">
                  <SafeIcon icon={FiIcons.FiHeart} className="h-8 w-8 text-cyan-600 mx-auto mb-3" />
                  <h4 className="font-bold text-slate-800">Pflege</h4>
                </div>
                <div className="bg-slate-100 p-6 rounded-xl text-center">
                  <SafeIcon icon={FiIcons.FiTool} className="h-8 w-8 text-cyan-600 mx-auto mb-3" />
                  <h4 className="font-bold text-slate-800">Handwerk</h4>
                </div>
                <div className="bg-slate-100 p-6 rounded-xl text-center">
                  <SafeIcon icon={FiIcons.FiTruck} className="h-8 w-8 text-cyan-600 mx-auto mb-3" />
                  <h4 className="font-bold text-slate-800">Logistik</h4>
                </div>
                <div className="bg-slate-100 p-6 rounded-xl text-center">
                  <SafeIcon icon={FiIcons.FiCoffee} className="h-8 w-8 text-cyan-600 mx-auto mb-3" />
                  <h4 className="font-bold text-slate-800">Gastronomie</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-blue-900 mb-12">Der Ablauf</h2>
          <div className="grid md:grid-cols-4 gap-8">
            {steps.map((step, idx) => (
              <div key={idx} className="bg-white p-6 rounded-xl shadow-sm border border-slate-100 relative">
                <div className="w-10 h-10 bg-cyan-100 text-cyan-700 rounded-full flex items-center justify-center font-bold text-lg mb-4">
                  {idx + 1}
                </div>
                <h3 className="text-xl font-bold text-blue-900 mb-2">{step.title}</h3>
                <p className="text-slate-600 text-sm">{step.desc}</p>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-12">
            <Link to="/bewerber" className="bg-blue-900 text-white font-bold py-3 px-8 rounded-md hover:bg-blue-800 transition-colors inline-block">
              Jetzt Profil anlegen
            </Link>
          </div>
        </div>
      </section>
    </PageWrapper>
  );
};

export default InternationaleFachkraefte;